import ReviewRatingPresenter from './ReviewRatingPresenter';

import {
  CapaQuotationPartnerRfqReviewResult,
  CapaReviewPointRatio
} from '@generated/graphql';

interface Props {
  reviewInfo?: CapaQuotationPartnerRfqReviewResult;
}

const ReviewRatingContainer = ({ reviewInfo }: Props) => {
  const avgPoint = reviewInfo?.reviewAveragePoint ?? 0;
  const count = reviewInfo?.reviewCount ?? 0;

  const pointRatio: Omit<CapaReviewPointRatio, '__typename'> = {
    five: reviewInfo?.reviewPointRatio?.five ?? 0,
    four: reviewInfo?.reviewPointRatio?.four ?? 0,
    three: reviewInfo?.reviewPointRatio?.three ?? 0,
    two: reviewInfo?.reviewPointRatio?.two ?? 0,
    one: reviewInfo?.reviewPointRatio?.one ?? 0
  };

  return (
    <ReviewRatingPresenter
      avgPoint={avgPoint}
      count={count}
      pointRatio={pointRatio}
    />
  );
};

export default ReviewRatingContainer;
